import { lengthMenu } from '@/plugins/lengthMenu'
import { datePickerLocale } from '@/plugins/datePickerLocale'
import store from '@/store/store'
import { mapState } from 'vuex'

export default {
  install (Vue, options) {
    Vue.prototype.$lengthMenu = lengthMenu
    Vue.prototype.$datepickerlocale = datePickerLocale

    Vue.mixin({
      data () {
        return {
          administrators: [
            process.env.VUE_APP_ROLE_ADMIN,
            'admin'
          ]
        }
      },
      computed: {
        ...mapState({
          userLogged: state => state.user.data,
          userRoles: state => state.user.data ? state.user.data.roles : null,
          userPermissions: state => state.user.data ? state.user.data.permissions : null
        }),
        userAvatar () {
          if (this.userLogged && this.userLogged.avatar) {
            return `${process.env.VUE_APP_API}/${this.userLogged.avatar}`
          }
          return '/img/avatar.jpg'
        }
      },
      methods: {
        showToastr () {
          this.$toastr(
            'success',
            this.$t('string.theRequestHaveBeenProcessed'),
            this.$t('string.success')
          )
        },
        getName (object) {
          if (object) {
            if (object.hasOwnProperty('name_' + this.$i18n.locale)) {
              return object['name_' + this.$i18n.locale]
            } else if (object.hasOwnProperty('name')) {
              return object.name
            } else if (object.hasOwnProperty('title')) {
              return object.title
            }
          }
          return this.$t('string.na')
        },
        getDateFormat (date, format = process.env.VUE_APP_DATE_FORMAT) {
          if (this.$moment(date).isValid()) {
            return this.$moment(date).format(format)
          }
          return this.$t('string.na')
        },
        clearEventHandler (classNames) {
          classNames.map((className) => {
            return $(document).off('click', className)
          })
        },
        currentFormat (amount, currency = 'USD') {
          if (amount) {
            return (parseFloat(amount)).toLocaleString('en-US', {
              style: 'currency',
              currency: currency
            })
          }
          return '$0.00'
        },
        onConfirm (options) {
          const self = this
          return new Promise((resolve, reject) => {
            this.$swal.fire(Object.assign({
              title: self.$t('label.swal.title'),
              text: self.$t('label.swal.desc'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: self.$t('label.swal.no'),
              confirmButtonText: self.$t('label.swal.yes')
            }, options)).then((result) => {
              if (result.value) {
                resolve({
                  accept: true
                })
              } else {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({
                  accept: false
                })
              }
            })
          })
        },
        onDeleted () {
          this.$swal.fire(
            this.$t('string.deleted'),
            this.$t('string.yourDataHasBeenDeleted!'),
            'success'
          )
        },
        clearEventHandlers (classNames) {
          if (classNames.length > 0) {
            classNames.map((className) => {
              return $(document).off('click', className)
            })
          }
        },
        onResponseError (error) {
          if (error.response && error.response.status) {
            const status = error.response.status
            if (status === 403) {
              this.showAccessDenied()
              this.$router.push({ name: 'unauthorized' })
            } else {
              if (status === 401) {
                localStorage.removeItem('token')
                localStorage.removeItem('fromRoutePath')
                store.commit('auth/setExpiredSession', true)
                this.$router.push({ name: 'login' })
              } else {
                const message = error.response.data.message
                if (message && message.hasOwnProperty('message_en')) {
                  this.$toastr('error', message['message_' + this.$i18n.locale], this.$t('string.error'))
                } else {
                  this.$toastr('error', message, this.$t('string.error'))
                }
              }
            }
          } else {
            let message = error
            try {
              message = error.response.data.message
            } catch (e) {
            }
            this.$toastr('error', message, this.$t('string.error'))
          }
        },
        onResponseSuccess () {
          this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
        },
        getUserInfo () {
          const self = this
          this.$axios.post(this.$base_api + '/api/v1/user/get-roles-and-permissions')
            .then((response) => {
              const result = response.data.data
              self.$store.dispatch('user/setUser', { user: result.user })
              // store roles
              self.$store.commit('user/setRoles', result.roles)

              // store permission
              self.$store.commit('user/setPermissions', result.permissions)
            }).catch(error => {
              self.onResponseError(error)
            })
        },
        can (permissions) {
          if (!permissions || permissions.length === 0 || this.$store.getters['user/isAdmin']) {
            return true
          }

          if (!this.userPermissions) {
            return false
          }

          return this.userPermissions.some(permission => permissions.includes(permission))
        },
        hasRoles (roles) {
          return this.$store.getters['user/isAdmin'] || this.onlyHasRoles(roles)
        },
        onlyHasRoles (roles) {
          if (!roles || roles.length === 0) {
            return true
          }

          if (!this.userRoles) {
            return false
          }

          return this.userRoles.some(role => roles.includes(role))
        },
        isAdmin () {
          if (!this.userRoles) {
            return false
          }
          return this.userRoles.some(role => this.administrators.includes(role))
        },
        showAccessDenied () {
          this.$toastr('error', 'You have no right to access.', 'Access Denied!')
        },
        onAccessDenied (xhr) {
          const message = (JSON.parse(xhr.responseText)).message
          this.$toastr('error', message, 'Error')

          if (xhr.status === 401) {
            this.$router.push({ name: 'unauthorized' })
          }
        },
        onResizeWindow () {
          $(function () {
            $(window).resize()
            $(window).resize()
          })
        }
      }
    })
  }
}
